<template>
    <section v-if="ranked.length > 0">
        <div class="flex items-center justify-between gap-4 mb-4">
            <div class="label-section">Per-section distribution · Sorted by score</div>
            <DistributionLegend :max-score="legendMaxScore" />
        </div>
        <div class="flex flex-col gap-5">
            <div v-for="s in ranked" :key="s.section_id">
                <div class="flex items-start justify-between gap-3 mb-1.5">
                    <div class="body-small-bold text-valence-grey-850 leading-snug">{{ s.title }}</div>
                    <div class="flex items-center gap-2 shrink-0">
                        <span class="body-small-bold text-valence-blue-600">{{ s.avg?.toFixed(2) ?? "—" }}</span>
                    </div>
                </div>
                <DistributionBar :distribution="s.distribution ?? []" :max-score="s.max_score" />
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { computed } from "vue";

import DistributionBar from "./DistributionBar.vue";
import DistributionLegend from "./DistributionLegend.vue";
import type { SectionAggregate } from "./types";

interface Props {
    sections: SectionAggregate[];
}

const props = defineProps<Props>();

// Show top-level sections only — sub-section detail belongs in the per-question
// view. Skip sections without a usable distribution (older reports or empty).
const ranked = computed(() =>
    props.sections
        .filter((s) => s.depth === 0 && s.avg !== null && (s.distribution?.length ?? 0) > 0)
        .slice()
        .sort((a, b) => (a.avg ?? Infinity) - (b.avg ?? Infinity)),
);

const legendMaxScore = computed(() => ranked.value[0]?.max_score ?? ranked.value[0]?.distribution?.length ?? 5);
</script>
